import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M9 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM.746 9.018A2.4 2.4 0 0 1 3.074 7.2h3.618A5.974 5.974 0 0 0 6 10c0 .701.12 1.374.341 2H0l.746-2.982ZM18 10a5.99 5.99 0 0 1-.341 2H24l-.745-2.982A2.4 2.4 0 0 0 20.925 7.2h-3.618c.442.836.692 1.789.692 2.8ZM21 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM12 14a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM8.098 15.5c-1.468 0-2.748 1.015-3.104 2.462L4 22h16l-.994-4.038c-.356-1.447-1.636-2.462-3.104-2.462H8.098Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }